(() => {
  if (window.fxlManualMarketReady) return;
  window.fxlManualMarketReady = true;
  const closeMarket = (details, focus = false) => {
    details.open = false;
    if (focus) details.querySelector('.fxl-market__trigger')?.focus();
  };
  const initialize = (root = document) => {
    root.querySelectorAll('[data-fxl-market]').forEach((details) => {
      if (details.dataset.marketReady) return;
      details.dataset.marketReady = 'true';
      details.addEventListener('toggle', () => {
        if (!details.open) return;
        document.querySelectorAll('[data-fxl-market][open]').forEach((other) => {
          if (other !== details) closeMarket(other);
        });
      });
      details.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          closeMarket(details, true);
        }
      });
      details.querySelector('form')?.addEventListener('submit', (event) => {
        const form = event.currentTarget;
        // Keep product variant, search and preview state; discard previous explicit market overrides.
        const returnTo = new URL(window.location.href);
        ['country', 'currency', 'country_code'].forEach((key) => returnTo.searchParams.delete(key));
        const returnInput = form.querySelector('[name="return_to"]');
        if (returnInput) returnInput.value = returnTo.pathname + returnTo.search + returnTo.hash;
        details.setAttribute('aria-busy', 'true');
        const note = details.querySelector('.fxl-market__note');
        if (note) note.textContent = 'Updating country and currency…';
      });
    });
  };
  const dismissOutside = (event) => {
    const path = event.composedPath();
    document.querySelectorAll('[data-fxl-market][open]').forEach((details) => {
      const insideControl = ['.fxl-market__trigger', '.fxl-market__panel'].some((selector) => {
        const element = details.querySelector(selector);
        return element && (path.includes(element) || element.contains(event.target));
      });
      if (!insideControl) closeMarket(details);
    });
  };
  // Capture outside interactions before other widgets stop event bubbling.
  // Do not prevent the original click, scroll, link or form action.
  document.addEventListener('pointerdown', dismissOutside, { capture: true, passive: true });
  document.addEventListener('click', dismissOutside, true);
  document.addEventListener('focusin', (event) => {
    document.querySelectorAll('[data-fxl-market][open]').forEach((details) => {
      if (!details.contains(event.target)) closeMarket(details);
    });
  });
  window.addEventListener('pageshow', () => {
    document.querySelectorAll('[data-fxl-market]').forEach((details) => {
      details.removeAttribute('aria-busy');
      const note = details.querySelector('.fxl-market__note');
      if (note) note.textContent = 'Prices update after you choose a country.';
    });
  });
  document.addEventListener('shopify:section:load', () => initialize());
  initialize();
})();
